import styled from 'styled-components';
import { Anchor } from '@atlassiansox/bxp-content-framework';
export const LinkBlockContainer = styled.div `
  height: 100%;
  opacity: 1;
  position: relative;
  transform: translate3d(0, 0, 0);
  transition: 250ms ease-out;
  &:hover {
    opacity: ${({ lighten }) => (lighten ? 0.8 : 1)};
    transform: ${({ lift }) => lift ? 'translate3d(0, -4px, 0)' : 'translate3d(0, 0, 0)'};
  }
`;
export const LinkBlockAnchor = styled(Anchor) `
  display: block;
  height: 0;
  width: 0;
`;
export const LinkBlockAnchorChild = styled.span `
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20; //to be above other position-absolute elements in the parent
`;
//# sourceMappingURL=UiLinkBlock.styles.js.map